import { render, staticRenderFns } from "./TablaSim.vue?vue&type=template&id=1a0f3669&"
import script from "./TablaSim.vue?vue&type=script&lang=ts&"
export * from "./TablaSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a0f3669', component.options)
    } else {
      api.reload('1a0f3669', component.options)
    }
    module.hot.accept("./TablaSim.vue?vue&type=template&id=1a0f3669&", function () {
      api.rerender('1a0f3669', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/TablaSim.vue"
export default component.exports